import { createContext, useContext, useMemo, useState, type ReactNode } from "react";

type SidebarContextValue = { collapsed: boolean; setCollapsed: (v: boolean) => void };
const Ctx = createContext<SidebarContextValue | null>(null);

export function SidebarProvider({ children }: { children: ReactNode }) {
  const [collapsed, setCollapsed] = useState(false);
  const value = useMemo(() => ({ collapsed, setCollapsed }), [collapsed]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useSidebar(): SidebarContextValue {
  const v = useContext(Ctx);
  if (!v) throw new Error("useSidebar must be used within SidebarProvider");
  return v;
}
